import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import {
  FileComponent,
  SalesDropzone,
  FileDropzone,
  NewDropzone,
} from '../../../common/Dropzone/Dropzone';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import { MembershipImage } from './LandingComponents';
import {
  paymentMethods,
  banksOptions,
  cashBakOptions,
  genericPayments,
  bankTransferList,
  pagoMovilList,
  salesAgentPhoneNumber,
  idEnums,
  idCodes,
  PMandTransfers,
  validationAPIErrorCheckbox
} from '../../../../assets/helpers/options';
import paymentMethodCashea from '../../../../images/paymentMethodCashea.svg';
import bancamiga from '../../../../images/Bancamiga.png';
import zelleLogo from '../../../../images/zelle.png';
import venpayLogo from '../../../../images/venpay.png';
import mercantil from '../../../../images/mercantil.png';
import banesco from '../../../../images/banesco.png';
import paypal from '../../../../images/paymentMethodPaypal.svg';
import pagoMovil from '../../../../images/paymentMethodPagoMovil.svg';
import binancePayMethod from '../../../../images/binancePayMethod.svg';
import {
  capitalize,
  filterById,
  isPaymentMethodZelleOrPaypal,
  returnIGTF,
  validateOtpInput,
  validateOtpInputSent,
} from '../../../../assets/helpers/funciones';
import { Input } from '../../../common/Forms/Input/Input';
import { PaymentElement } from '@stripe/react-stripe-js';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import safePayment from '../../../../images/safePayment.svg';

import './LandingModals.scss';
import { notify } from '../../../../assets/helpers/toast';
import authService from '../../../../services/authService';

export const AccountsSelect = (props) => {
  const { handleGenericPaymentMethods, payment, methods, register, errors } =
    props;

  let options = [];
  options = methods;

  for (let i = 0; i < methods?.length; i++) {
    if (
      ![
        paymentMethods.CASH_BS,
        paymentMethods.CASH_USD,
        paymentMethods.CASH_EUR,
        ...genericPayments,
      ].includes(methods[i]?.name)
    ) {
      return null;
    }
  }
  return (
    <Input
      bootstrap={'col-12 col-md-6'}
      label={'Opciones de pago'}
      type={'select'}
      name={'paymentOption'}
      register={register}
      placeholder={''}
      options={options}
      errors={errors?.paymentOption?.message}
      disabled={true}
      onChange={() => {
        handleGenericPaymentMethods(payment?.paymentNumber);
      }}
    />
  );
};

export const RefComponent = (props) => {
  const {
    methods,
    paymentModal,
    payment,
    register,
    errors,
    watch,
    handleReferenceChange,
    handleOwnerChange,
  } = props;
  const selectedPaymentMethod =
    filterById(methods, watch('paymentOption')) || payment?.methods?.[0];

  for (let i = 0; i < methods?.length; i++) {
    if ([paymentMethods.CASH_BS].includes(methods[i]?.name)) {
      return null;
    }
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {![
          paymentMethods?.VENPAY,
          paymentMethods?.ZELLE,
          paymentMethods?.PAYPAL,
          paymentMethods?.NATIONAL_TDC,
          paymentMethods?.DEBITO_INMEDIATO,
        ].includes(payment?.methods[0]?.name) && (
            <div className={`input-component-container col-12 col-md-6`}>
              <label style={{ textAlign: 'center' }}>{`${[
                paymentMethods?.PAGO_EN_COMERCIO,
                paymentMethods?.RETENCION_IVA,
                paymentMethods?.RETENCION_ISLR,
              ].includes(payment?.methods[0]?.name)
                ? 'Número de Factura/Recibo'
                : 'Referencia de Pago'
                }  ${paymentModal?.paymentNumber > 1 ? paymentModal?.paymentNumber : ''
                }`}</label>
              <div>
                <div className="input-sublabel-container">
                  <input
                    name={`reference`}
                    value={payment?.reference}
                    onChange={handleReferenceChange}
                  />
                </div>
              </div>
            </div>
          )}
        {[
          paymentMethods?.VENPAY,
          paymentMethods?.ZELLE,
          paymentMethods?.PAYPAL,
        ].includes(payment?.methods[0]?.name) && (
            <div className={`input-component-container col-12 col-md-6`}>
              <label style={{ textAlign: 'center' }}>
                {'Titular de la cuenta'}
              </label>
              <div>
                <div className="input-sublabel-container">
                  <input
                    name={`owner`}
                    value={payment?.owner}
                    onChange={handleOwnerChange}
                  />
                </div>
              </div>
            </div>
          )}
        {[paymentMethods?.PUNTO_DE_VENTA].includes(
          selectedPaymentMethod?.name
        ) && (
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Lote de transacción'}
              type={'number'}
              name={`transactionBatch${payment?.paymentNumber}`}
              register={register}
              placeholder={''}
              centeredLabel={true}
              errors={
                errors?.[`transactionBatch${payment?.paymentNumber}`]?.message
              }
              min={'0'}
            />
          )}

      </div>
    </>
  );
};

export const InitialComponent = (props) => {
  const {
    payment,
    handleCasheaInitial,
    paymentImage,
    removeImage,
    getRootProps,
    getInputProps,
    options,
    watch,
  } = props;

  return (
    <>
      <div className={`input-component-container col-12 col-md-6`}>
        <label style={{ textAlign: 'center' }}>{`Monto USD`}</label>
        <div>
          <div className="input-sublabel-container">
            <input
              type="number"
              name={`amount`}
              value={payment?.amount}
              onChange={handleCasheaInitial}
              disabled={
                watch('paymentMethodsQuantity') === '1' ||
                (watch('paymentMethodsQuantity') === '2' &&
                  watch('amount1') &&
                  payment?.paymentNumber === 2)
              }
            ></input>
          </div>
        </div>
      </div>
      <div className={`input-component-container col-12 col-md-6`}>
        <label style={{ textAlign: 'center' }}>{`Método de Pago`}</label>
        <select
          value={payment?.metodo}
          onChange={handleCasheaInitial}
          name="metodo"
        >
          <option value=""></option>
          {options?.paymemtMethodOptions?.map((o, i) => (
            <option key={o?._id} value={o?._id}>
              {capitalize(o?.name)}
            </option>
          ))}
        </select>
      </div>
      {!isPaymentMethodZelleOrPaypal(
        payment.metodo,
        options.paymemtMethodOptions
      ) && (
          <div className={`input-component-container col-12 col-md-6`}>
            <label
              style={{ textAlign: 'center' }}
            >{`Referencia pago inicial`}</label>
            <div>
              <div className="input-sublabel-container">
                <input
                  type="text"
                  name={`transactionId`}
                  value={payment?.transactionId}
                  onChange={handleCasheaInitial}
                ></input>
              </div>
            </div>
          </div>
        )}
      <div className={`input-component-container col-12 col-md-6`}>
        <label style={{ textAlign: 'center' }}>{`Referencia Cashea`}</label>
        <div>
          <div className="input-sublabel-container">
            <input
              type="number"
              name={`referenceCashea`}
              value={payment?.referenceCashea}
              onChange={handleCasheaInitial}
              disabled={
                watch('paymentMethodsQuantity') === '2' &&
                watch('amount1') &&
                payment?.paymentNumber === 2
              }
            ></input>
          </div>
        </div>
      </div>
      {/* FOR ZELLE PAYMENTS */}
      {isPaymentMethodZelleOrPaypal(
        payment.metodo,
        options.paymemtMethodOptions
      ) && (
          <div className={`input-component-container col-12 col-md-6`}>
            <label
              style={{ textAlign: 'center' }}
            >{`Titular de la cuenta`}</label>
            <div>
              <div className="input-sublabel-container">
                <input
                  type="text"
                  name={`owner`}
                  value={payment?.owner}
                  onChange={handleCasheaInitial}
                ></input>
              </div>
            </div>
          </div>
        )}
      {/* {![paymentMethods?.PUNTO_DE_VENTA, paymentMethods?.TDC]?.includes(
        payment?.methods[0]?.name
      ) && ( */}
      <div className="buttons-center-container">
        {paymentImage ? (
          <FileComponent
            file={paymentImage}
            remove={() => removeImage(payment?.paymentNumber)}
          />
        ) : (
          <SalesDropzone
            instructions={'Adjuntar Comprobante *'}
            maxWeight={'(JPG, PNG, PDF, máx. 3MB)'}
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            message="Arrastrar o buscar Documento"
          />
        )}
      </div>
      {/* )} */}
    </>
  );
};

export const PaymentMethodDetails = (props) => {
  const { method, methods, watch } = props;

  const filteredMethod = methods?.filter(
    (m) =>
      m?._id === method?._id &&
      ![paymentMethods.CASH_BS, paymentMethods.CASH_USD]?.includes(m?.name)
  );
  const genericMethods = methods?.filter((m) =>
    [...bankTransferList, ...pagoMovilList]?.includes(m?.name)
  );

  if (genericMethods?.length > 0 && !watch('paymentOption')) {
    return null;
  }

  if (
    genericMethods?.length > 0 &&
    watch('paymentOption') &&
    method?._id !== watch('paymentOption')
  ) {
    return null;
  }

  if (filteredMethod?.length > 0) {
    return (
      <p style={{ margin: '24px 12px 24px 12px' }}>
        {method?.details?.account && (
          <>
            Cuenta: <b>{method?.details?.account}</b> <br />
          </>
        )}
        {method?.details?.accountNumber && (
          <>
            Numero de Cuenta: <b>{method?.details?.accountNumber}</b> <br />
          </>
        )}
        {method?.details?.bank && (
          <>
            Banco: <b>{method?.details?.bank}</b> <br />
          </>
        )}
        {method?.details?.phone && (
          <>
            Telefono: <b>{method?.details?.phone}</b> <br />
          </>
        )}
        {method?.details?.rif && (
          <>
            RIF: <b>{method?.details?.rif}</b> <br />
          </>
        )}
      </p>
    );
  } else return null;
};

export const AmounComponent = (props) => {
  const { amount, amountBsS } = props;

  if (!amountBsS) {
    return null;
  }
  return (
    <div className="ammount-container">
      <h5>Monto</h5>
      <h6>{amount?.toFixed(2) + ' $    ' + amountBsS?.toFixed(2) + ' Bs'}</h6>
    </div>
  );
};

export const MethodLogoContainer = (props) => {
  const { methods } = props;
  if (methods?.length > 0) {
    return (
      <div className="payment-method-logos-container">
        {methods?.map((m, i) => (
          <MethodLogo key={m?.name + i} name={m?.name} />
        ))}
      </div>
    );
  } else return null;
};

export const MethodLogo = (props) => {
  const { name } = props;

  let src = '';
  switch (name) {
    case paymentMethods.CASHEA:
      src = paymentMethodCashea;
      break;
    case paymentMethods.ZELLE:
      src = zelleLogo;
      break;
    case paymentMethods.VENPAY:
      src = venpayLogo;
      break;
    case paymentMethods.TRANSFERENCIA_MERCANTIL:
      src = mercantil;
      break;
    case paymentMethods.TRANSFERENCIA_BANESCO:
      src = banesco;
      break;
    case paymentMethods.PAYPAL:
      src = paypal;
      break;
    case paymentMethods.PAGO_MÓVIL:
      src = pagoMovil;
      break;
    case paymentMethods.PAGO_MÓVIL_BANCAMIGA:
      src = pagoMovil;
      break;
    case paymentMethods.BINANCE:
      src = binancePayMethod;
      break;

    default:
  }
  if (src) {
    return <img src={src} alt="src" />;
  } else return null;
};

export const IGTF = (props) => {
  const { methods } = props;

  let isDollar = false;

  for (let i = 0; i < methods.length; i++) {
    if (methods[i].currency === 'USD') {
      isDollar = true;
    }
  }

  if (!isDollar) {
    return null;
  }

  return (
    <p className="igtf-message-container">
      Este monto incluye el <b>IGTF ({returnIGTF()}%)</b> por utilizar un método
      de pago de une monede distinta a la de curso legal en Venezuela. Para más
      información, consulte la <b>Gaceta Oficial N°6.687</b>
    </p>
  );
};

export const NewPaymentModal = (props) => {
  const {
    fileUploaded,
    setFileUploaded,
    cancelPayment,
    acceptPayment,
    requestOtTP,
    watch,
    register,
    errors,
    showErrorAPI,
    payment,
    handleReferenceChange,
    handleOwnerChange,
    control,
    handleGenericPaymentMethods,
    cashReceiverOptions,
    setValue,
    getPaymentsData,
  } = props;

  // Check if the paymet method is PM or bank transfer
  const genericMethods = payment?.methods?.filter((m) =>
    [...bankTransferList, ...pagoMovilList]?.includes(m?.name)
  );

  const selectedPaymentMethodName = filterById(
    payment?.methods,
    watch('paymentOption')
  )?.name;

  const createAdjustmentFile = {
    name: 'Adjuntar Comprobante *',
    instructions: 'Adjuntar Comprobante *',
    label: '(JPG, PNG, PDF, máx. 3MB)',
    message: 'Arrastrar o buscar Documento',
    uploaded: '',
  };

  const handleCardDateChange = (value, index) => {
    let formattedValue = value.replace(/\D/g, '');
    if (formattedValue.length > 2) {
      formattedValue =
        formattedValue.substring(0, 2) + '/' + formattedValue.substring(2, 4);
    }

    if (formattedValue.length > 5) {
      formattedValue = formattedValue.substring(0, 5);
    }

    if (formattedValue.length >= 2) {
      const monthPart = formattedValue.substring(0, 2);
      const month = parseInt(monthPart, 10);
      if (month > 12) {
        formattedValue = '12' + formattedValue.substring(2);
      }
      if (month === 0) {
        // Evitar 00 para mes
        formattedValue = '01' + formattedValue.substring(2);
      }
    }
    setValue(`cardDate${index}`, formattedValue);
  };

  return (
    <Modal
      size="lg"
      centered
      show={payment?.isOpen}
      onHide={() => cancelPayment(payment?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        {payment?.selectedMembership?.code ? (
          <MembershipImage
            membership={{ code: payment?.selectedMembership?.code }}
          />
        ) : null}
        <div className="landing-payment-modal-header">
          <AmounComponent
            amount={payment?.amount}
            amountBsS={payment?.amountBsS}
          />

          <MethodLogoContainer methods={payment?.methods} />
        </div>
        <div className="landing-payment-modal-body">
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>
          {payment?.methods?.map((p) => (
            <PaymentMethodDetails
              key={p?.details?.account}
              method={p}
              paymentOption={watch('paymentOption')}
              methods={payment?.methods}
              watch={watch}
            />
          ))}
          <div
            style={{ width: '100%' }}
            className="row landing-payment-modals-form"
          >
            <AccountsSelect
              register={register}
              errors={errors}
              methods={payment?.methods}
              payment={payment}
              handleGenericPaymentMethods={handleGenericPaymentMethods}
            />

            <AmountCashReceived
              register={register}
              errors={errors}
              watch={watch}
              methods={payment?.methods}
              payment={payment}
            />
          </div>
          {![
            paymentMethods?.C2P_BANCAMIGA,
            paymentMethods?.NATIONAL_TDC,
            paymentMethods?.DEBITO_INMEDIATO,
          ].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <div className="buttons-center-container">
                <NewDropzone
                  fileUploaded={fileUploaded}
                  setFileUploaded={setFileUploaded}
                  img={createAdjustmentFile}
                  index={payment?.paymentNumber}
                  getPaymentsData={getPaymentsData}
                />
              </div>
            )}
          {![paymentMethods?.C2P_BANCAMIGA].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <div
                style={{ width: '100%' }}
                className="row landing-payment-modals-form"
              >
                <RefComponent
                  paymentModal={payment}
                  register={register}
                  errors={errors}
                  methods={payment?.methods}
                  payment={payment}
                  watch={watch}
                  handleReferenceChange={handleReferenceChange}
                  handleOwnerChange={handleOwnerChange}
                />
              </div>
            )}

          {[paymentMethods?.DEBITO_INMEDIATO].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <div className="row">
                <Input
                  bootstrap={'col-4 col-sm-2 col-md-2'}
                  label={'C.I / RIF*'}
                  type={'select'}
                  name={`identificationType${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  options={idCodes}
                  errors={errors?.identificationType?.message}
                  disabled={watch(`otp${payment?.paymentNumber}`)}
                />
                {[idEnums?.J, idEnums?.E, idEnums?.P]?.includes(
                  watch('identificationType')
                ) && (
                    <Input
                      bootstrap={'col-8 col-sm-4 col-md-4'}
                      label={''}
                      type={'text'}
                      name={`identification${payment?.paymentNumber}`}
                      register={register}
                      placeholder={''}
                      errors={errors?.identification?.message}
                      disabled={watch(`otp${payment?.paymentNumber}`)}
                    />
                  )}
                {![idEnums?.J, idEnums?.E, idEnums?.P]?.includes(
                  watch('identificationType')
                ) && (
                    <Input
                      bootstrap={'col-8 col-sm-4 col-md-4'}
                      label={''}
                      type={'number'}
                      name={`identification${payment?.paymentNumber}`}
                      register={register}
                      placeholder={''}
                      errors={errors?.identification?.message}
                      disabled={watch(`otp${payment?.paymentNumber}`)}
                    />
                  )}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Banco'}
                  type={'select'}
                  name={`bank${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  options={banksOptions}
                  errors={errors?.[`bank${payment?.paymentNumber}`]?.message}
                  disabled={watch(`otp${payment?.paymentNumber}`)}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Nro. Teléfono'}
                  type={'number'}
                  name={`phone${payment?.paymentNumber}`}
                  placeholder={'4143579865'}
                  register={register}
                  errors={errors?.[`phone${payment?.paymentNumber}`]?.message}
                  disabled={watch(`otp${payment?.paymentNumber}`)}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'OTP *'}
                  type={'text'}
                  control={control}
                  name={`otp${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  errors={errors?.phone?.message}
                  numpadForMobile={true}
                  disabled={validateOtpInput(watch, payment?.paymentNumber)}
                />
              </div>
            )}

          {[paymentMethods?.C2P_BANCAMIGA].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <div className="row">
                <Input
                  bootstrap={'col-4 col-sm-2 col-md-6'}
                  label={'Clave dinámica *'}
                  type={'text'}
                  name={'otp'}
                  register={register}
                  placeholder={''}
                  errors={errors?.otp?.message}
                />
                <Input
                  bootstrap={'col-4 col-sm-2 col-md-2'}
                  label={'C.I / RIF*'}
                  type={'select'}
                  name={'identificationType'}
                  register={register}
                  placeholder={''}
                  options={idCodes}
                  errors={errors?.identificationType?.message}
                />
                {[idEnums?.J, idEnums?.E, idEnums?.P]?.includes(
                  watch('identificationType')
                ) && (
                    <Input
                      bootstrap={'col-8 col-sm-4 col-md-4'}
                      label={''}
                      type={'text'}
                      name={'identification'}
                      register={register}
                      placeholder={''}
                      errors={errors?.identification?.message}
                    />
                  )}
                {![idEnums?.J, idEnums?.E, idEnums?.P]?.includes(
                  watch('identificationType')
                ) && (
                    <Input
                      bootstrap={'col-8 col-sm-4 col-md-4'}
                      label={''}
                      type={'number'}
                      name={'identification'}
                      register={register}
                      placeholder={''}
                      errors={errors?.identification?.message}
                    />
                  )}
              </div>
            )}
          {[
            paymentMethods?.PAGO_MÓVIL_BANCAMIGA,
            paymentMethods?.C2P_BANCAMIGA,
          ].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <div style={{ width: '100%' }} className="row">
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Nro. Teléfono asociado a pago móvil'}
                  type={'number'}
                  name={`phone${payment?.paymentNumber}`}
                  placeholder={'4143579865'}
                  register={register}
                  errors={errors?.[`phone${payment?.paymentNumber}`]?.message}
                  disabled={false}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  style={{
                    textAlign: 'center',
                    width: '100%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                  label={'Fecha de Pago'}
                  type={'date'}
                  name={`date${payment?.paymentNumber}`}
                  register={register}
                  errors={errors?.[`date${payment?.paymentNumber}`]?.message}
                  control={control}
                  disabled={false}
                  centeredLabel={true}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'¿Qué banco utilizaste?'}
                  type={'select'}
                  name={`bank${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  options={banksOptions}
                  errors={errors?.[`bank${payment?.paymentNumber}`]?.message}
                  disabled={false}
                />
              </div>
            )}

          {[paymentMethods?.TRANSFERENCIA_BANCAMIGA].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <div className="buttons-center-container">
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'¿Qué banco utilizaste?'}
                  type={'select'}
                  name={`bank${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  options={banksOptions}
                  errors={errors?.[`bank${payment?.paymentNumber}`]?.message}
                  disabled={false}
                  centeredLabel={true}
                />
              </div>
            )}
          {
            validationAPIErrorCheckbox.includes(filterById(payment?.methods, watch('paymentOption'))?.name) &&
            showErrorAPI && authService.getUser() &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
              <h6 style={{ color: 'red', marginRight: '10px', marginBottom: '0' }}>No Validado por API</h6>
              <Input
                bootstrap={''}
                label={''}
                type={'checkbox'}
                name={`skipApiValidationError${payment?.paymentNumber}`}
                register={register}
                placeholder={''}
                options={banksOptions}
                errors={errors?.[`skipApiValidationError${payment?.paymentNumber}`]?.message}
                disabled={false}
                centeredLabel={true}
              />
            </div>
          }
          {genericMethods?.length > 0 && (
            <p style={{ textAlign: 'center' }}>
              De existir un problema por favor ponte en contacto con nuestros
              asesores de venta <b>{salesAgentPhoneNumber}</b>{' '}
            </p>
          )}
          {[paymentMethods?.NATIONAL_TDC].includes(
            filterById(payment?.methods, watch('paymentOption'))?.name
          ) && (
              <>
                {!authService.getUser() &&
                  new Date() >= new Date('2026-01-26T00:00:00Z') ? (
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexFlow: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      style={{ width: '200px', borderRadius: '8px' }}
                      src={bancamiga}
                      alt=""
                    />
                    <div
                      style={{
                        backgroundColor: '#d4edda',
                        color: '#155724',
                        border: '1px solid #c3e6cb',
                        borderRadius: '4px',
                        padding: '12px',
                        margin: '16px 0',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                    >
                      {
                        '15% de descuento sobre la facturación si pagas con tus productos Bancamiga'
                      }
                    </div>{' '}
                  </div>
                ) : (
                  ''
                )}

                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-12'}
                    label={'Número de tarjeta '}
                    type={'text'}
                    name={`card${payment?.paymentNumber}`}
                    placeholder={'1234 1234 1234 1234'}
                    register={register}
                    errors={errors?.[`card${payment?.paymentNumber}`]?.message}
                    disabled={false}
                  />
                </div>
                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Fecha de vencimiento '}
                    type={'card-date'}
                    name={`cardDate${payment?.paymentNumber}`}
                    onChange={(e) =>
                      handleCardDateChange(e.target.value, payment?.paymentNumber)
                    }
                    placeholder={'MM/AA'}
                    register={register}
                    errors={errors?.[`card${payment?.paymentNumber}`]?.message}
                    disabled={false}
                  />
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Código de seguridad '}
                    type={'text'}
                    name={`cvc${payment?.paymentNumber}`}
                    placeholder={'CVC'}
                    register={register}
                    errors={errors?.[`cvc${payment?.paymentNumber}`]?.message}
                    disabled={false}
                  />
                </div>
                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Tipo de documento'}
                    type={'select'}
                    name={`identificationType${payment?.paymentNumber}`}
                    options={idCodes}
                    register={register}
                    capitalizeOff={true}
                    errors={
                      errors?.[`identificationType${payment?.paymentNumber}`]
                        ?.message
                    }
                    disabled={false}
                  />
                  <Input
                    bootstrap={'col-12 col-md-8'}
                    label={'Cédula'}
                    type={'text'}
                    name={`identification${payment?.paymentNumber}`}
                    register={register}
                    errors={
                      errors?.[`identification${payment?.paymentNumber}`]?.message
                    }
                    disabled={false}
                  />
                </div>
                {new Date() >= new Date('2026-01-26T00:00:00Z') ? (
                  <div
                    style={{
                      borderRadius: '4px',
                      marginTop: '12px',
                      textAlign: 'center',
                      fontWeight: 500,
                    }}
                  >
                    {
                      'No se permite la aplicación de doble descuento sobre una misma afiliación.'
                    }
                  </div>
                ) : (
                  ''
                )}
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  className="row"
                >
                  <img
                    style={{ width: '70%' }}
                    className="safePayment"
                    src={safePayment}
                    alt="safePayment"
                  />
                </div>
              </>
            )}

          {[
            paymentMethods?.CASH_BS,
            paymentMethods?.CASH_EUR,
            paymentMethods?.CASH_USD,
            paymentMethods?.PUNTO_DE_VENTA,
          ].includes(selectedPaymentMethodName) && (
              <div className="buttons-center-container">
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={
                    selectedPaymentMethodName === paymentMethods?.PUNTO_DE_VENTA
                      ? 'Sede'
                      : 'Caja de venta'
                  }
                  type={'select'}
                  name={`cashReceiver${payment?.paymentNumber}`}
                  register={register}
                  placeholder={''}
                  options={cashReceiverOptions}
                  errors={
                    errors?.[`cashReceiver${payment?.paymentNumber}`]?.message
                  }
                  disabled={false}
                  centeredLabel={true}
                />
              </div>
            )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton
          label={`Cancelar `}
          action={() => cancelPayment(payment?.paymentNumber)}
        />
        {[paymentMethods?.DEBITO_INMEDIATO].includes(
          payment?.methods[0]?.name
        ) &&
          !watch(`otp${payment?.paymentNumber}`) && (
            <ActionButton
              label={`Solicitar OTP `}
              disabled={validateOtpInputSent(watch, payment?.paymentNumber)}
              action={() => requestOtTP()}
            />
          )}
        {(![paymentMethods?.DEBITO_INMEDIATO].includes(
          payment?.methods[0]?.name
        ) ||
          watch(`otp${payment?.paymentNumber}`)) && (
            <ActionButton label={`Pagar `} action={() => acceptPayment()} />
          )}
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const AmountCashReceived = (props) => {
  const { payment, methods, register, errors } = props;

  for (let i = 0; i < methods?.length; i++) {
    if (
      ![
        paymentMethods.CASH_USD,
        paymentMethods.CASH_BS,
        paymentMethods.CASH_EUR,
      ].includes(methods[i]?.name)
    ) {
      return null;
    }
  }

  return (
    <Input
      bootstrap={'col-12 col-md-6'}
      label={'Monto Recibido $'}
      type={'number'}
      name={`paid${payment.paymentNumber}`}
      register={register}
      placeholder={''}
      errors={errors?.[`paid${payment.paymentNumber}`]?.message}
      disabled={false}
    />
  );
};

export const CasheaModal = (props) => {
  const {
    cancelPayment,
    acceptPayment,
    dollarRate,
    register,
    errors,
    payment,
    handleCasheaInitial,
    removeImage,
    paymentImage,
    getRootProps,
    getInputProps,
    watch,
    options,
  } = props;

  return (
    <Modal
      size="lg"
      centered
      show={payment?.isOpen}
      onHide={() => cancelPayment(payment?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <MembershipImage
          membership={{ code: payment?.selectedMembership?.code }}
        />
        <div className="landing-payment-modal-header">
          <AmounComponent
            selectedMembership={payment?.selectedMembership}
            paymentModal={payment}
            dollarRate={dollarRate}
            amount={payment?.amount}
            amountBsS={payment?.amountBsS}
          />

          <MethodLogoContainer methods={payment?.methods} />
        </div>
        <div className="landing-payment-modal-body">
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>
          <div
            style={{ width: '100%' }}
            className="row landing-payment-modals-form"
          >
            <InitialComponent
              paymentModal={payment}
              register={register}
              errors={errors}
              watch={watch}
              methods={payment?.methods}
              payment={payment}
              handleCasheaInitial={handleCasheaInitial}
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              paymentImage={paymentImage}
              removeImage={removeImage}
              options={options}
            />
          </div>
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton
          label={`Cancelar `}
          action={() => cancelPayment(payment?.paymentNumber)}
        />
        {payment?.amount > 0 &&
          (payment?.transactionId ||
            isPaymentMethodZelleOrPaypal(
              payment.metodo,
              options.paymemtMethodOptions
            )) &&
          payment?.metodo &&
          paymentImage && (
            <ActionButton
              label={`Pagar ${payment?.amount} $`}
              action={() => acceptPayment()}
            />
          )}
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const StripeModal = (props) => {
  const { stripeModal, handleStipeModal, clientSecret, successfulStripe } =
    props;

  const publishableKey = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  return (
    <Modal
      size="lg"
      centered
      show={stripeModal?.isOpen}
      onHide={() => handleStipeModal(0, stripeModal?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <MembershipImage
          membership={{ code: stripeModal?.selectedMembership?.code }}
        />
        <div className="landing-payment-modal-header">
          <AmounComponent
            selectedMembership={stripeModal?.selectedMembership}
            paymentModal={stripeModal}
            amount={stripeModal?.amount}
            amountBsS={stripeModal?.amountBsS}
          />

          {/* <MethodLogoContainer methods={paymentModal?.methods} /> */}
        </div>
        <div className="landing-payment-modal-body">
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>

          {clientSecret && publishableKey && (
            <Elements stripe={publishableKey} options={{ clientSecret }}>
              <CheckoutForm
                stripeModal={stripeModal}
                handleStipeModal={handleStipeModal}
                successfulStripe={successfulStripe}
              />
            </Elements>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CheckoutForm = (props) => {
  const { stripeModal, handleStipeModal, successfulStripe } = props;
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/completion`,
      },
      redirect: 'if_required',
    });

    if (error?.type === 'card_error' || error?.type === 'validation_error') {
      setMessage(error.message);
    }
    if (paymentIntent?.status === 'succeeded') {
      notify('Su pago ha sido registrado con éxito', 'success');
      successfulStripe(stripeModal.paymentNumber);
    } else {
      setMessage('An unexpected error occured.');
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form">
      <PaymentElement id="payment-element" />
      {message && <div id="payment-message">{message}</div>}

      {!isProcessing && (
        <div
          style={{ margin: '24px 0px' }}
          className="buttons-center-container"
        >
          <AltButton
            label={`Cancelar `}
            action={() => handleStipeModal(0, stripeModal.paymentNumber)}
          />

          {isProcessing || !stripe || !elements ? null : (
            <ActionButton label={`Pagar `} action={handleSubmit} />
          )}
        </div>
      )}
    </form>
  );
};

export const CashBackComponent = (props) => {
  const {
    register,
    errors,
    watch,
    options,
    onChange,
    handleDrop,
    cashBackImage,
    removeFile,
    handleCashbackModal,
    errorsDropzone,
    shouldDisableReferenceAndReceipt,
  } = props;
  const filterMethods = options?.paymemtMethodOptions?.filter(
    (m) => ![paymentMethods?.CASHEA, paymentMethods?.RESERVE]?.includes(m?.name)
  );

  const validatePMDataCashback = (i) => {
    if (watch(`cashBackphone${i}`)) {
      return true
    }
  }



  if (watch('paid') && watch('paidBsS')) {
    return (
      <>
        <div className="col-12">
          <h5 style={{ margin: '12px 0px' }}>Vuelto</h5>
        </div>
        <div className="row">
          <Input
            bootstrap={'col-12 col-md-2'}
            label={'Monto total Recibido USD $ *'}
            type={'number'}
            name={'paid'}
            register={register}
            placeholder={''}
            errors={errors?.paid?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-12 col-md-2'}
            label={'Monto total Recibido BsS*'}
            type={'number'}
            name={'paidBsS'}
            register={register}
            placeholder={''}
            errors={errors?.paidBsS?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-12 col-md-2'}
            label={'Vuelto a entregar USD $ *'}
            type={'number'}
            name={'amountReturned'}
            register={register}
            options={options?.paymemtMethodOptions}
            placeholder={''}
            errors={errors?.amountReturned?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-12 col-md-2'}
            label={'Vuelto a entregar BsS $ *'}
            type={'number'}
            name={'amountReturnedBsS'}
            register={register}
            options={options?.paymemtMethodOptions}
            placeholder={''}
            errors={errors?.amountReturnedBsS?.message}
            disabled={true}
          />
          <div className="col-md-4"></div>
          <Input
            bootstrap={'col-12 col-md-3'}
            label={'Cantidad de métodos de vuelto *'}
            type={'select'}
            name={'cashbackMethodsQuantity'}
            register={register}
            options={cashBakOptions}
            placeholder={''}
            errors={errors?.cashbackMethodsQuantity?.message}
            onChange={() => onChange?.handleCashbackMethodsQuantity()}
          // disabled={true}
          />
          <div className="col-md-9"></div>

          <table className="table payments-table">
            <thead>
              <tr>
                <th scope="col">Método de vuelto</th>
                <th scope="col">Monto USD Vuelto</th>
                <th scope="col">Monto Bs Vuelto</th>
                <th scope="col">Referencia Vuelto</th>
                <th scope="col">Datos del vuelto</th>
                <th scope="col">Observación</th>
                <th scope="col">Adjuntar Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {Array.from({
                length: parseFloat(watch('cashbackMethodsQuantity')),
              }).map((_, i) => (
                <tr key={i}>
                  <td>
                    <Input
                      bootstrap={'col-12'}
                      // label={`Método de vuelto ${i + 1}*`}
                      type={'select'}
                      name={`returnedMethod${i}`}
                      register={register}
                      options={filterMethods}
                      placeholder={''}
                      errors={errors[`returnedMethod${i}`]?.message}
                    />
                  </td>
                  <td>
                    <Input
                      bootstrap={'col-12'}
                      // label={`Monto USD Vuelto ${i + 1} *`}
                      type={'number'}
                      name={`returnedAmount${i}`}
                      register={register}
                      placeholder={''}
                      errors={errors[`returnedAmount${i}`]?.message}
                      onChange={() => onChange?.handleCashbackBs(i)}
                      disabled={
                        parseFloat(watch('cashbackMethodsQuantity')) - 1 === i
                      }
                    />
                  </td>
                  <td>
                    <Input
                      bootstrap={'col-12'}
                      // label={`Monto Bs Vuelto ${i + 1} *`}
                      type={'number'}
                      name={`returnedAmountBsS${i}`}
                      register={register}
                      placeholder={''}
                      errors={errors[`returnedAmountBsS${i}`]?.message}
                      disabled={true}
                    />
                  </td>
                  <td>
                    <Input
                      bootstrap={'col-12'}
                      // label={`Referencia Vuelto ${i + 1} *`}
                      type={'text'}
                      name={`returnedReference${i}`}
                      register={register}
                      placeholder={''}
                      errors={errors[`returnedReference${i}`]?.message}
                      disabled={shouldDisableReferenceAndReceipt(watch(`returnedMethod${i}`))}
                    />
                  </td>
                  <td>
                    {PMandTransfers.includes(
                      filterById(
                        filterMethods,
                        watch(`returnedMethod${i}`)
                      )?.name
                    ) && <>

                        {
                          validatePMDataCashback(i) ?
                            <div className='row'>
                              <CashbackPMInfo watch={watch} i={i} />
                              <div className="buttons-center-container">
                                <ActionButton label="Editar" action={() => handleCashbackModal(i, true)} />
                              </div>
                            </div>

                            : <p onClick={() => handleCashbackModal(i, true)}>
                              Agregar Datos de Vuelto</p>
                        }
                      </>
                    }
                  </td>
                  <td>
                    <Input
                      bootstrap={'col-12'}
                      // label={`Observación ${i + 1} *`}
                      type={'textarea'}
                      name={`observation${i}`}
                      register={register}
                      placeholder={''}
                      errors={errors[`observation${i}`]?.message}
                    />
                  </td>
                  <td>
                    {
                      !shouldDisableReferenceAndReceipt(watch(`returnedMethod${i}`)) && (
                        <div className="col-12">
                          <FileDropzone
                            handleDrop={handleDrop}
                            index={i}
                            file={cashBackImage[`image${i}`]}
                            removeFile={removeFile}
                            error={errorsDropzone?.[`error${i}`]}
                          />
                        </div>
                      )
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  } else return null;
};

export const CashBackInput = (props) => {
  const {
    index,
    register,
    errors,
    options,
    onChange,
    file,
    removeFile,
    handleDrop,
    watch,
    errorsDropzone,
  } = props;

  return (
    <>
      <Input
        bootstrap={'col-12 col-md-2'}
        label={`Método de vuelto ${index + 1}*`}
        type={'select'}
        name={`returnedMethod${index}`}
        register={register}
        options={options?.filterMethods}
        placeholder={''}
        errors={errors[`returnedMethod${index}`]?.message}
      />
      <Input
        bootstrap={'col-12 col-md-2'}
        label={`Monto USD Vuelto ${index + 1} *`}
        type={'number'}
        name={`returnedAmount${index}`}
        register={register}
        placeholder={''}
        errors={errors[`returnedAmount${index}`]?.message}
        onChange={() => onChange?.handleCashbackBs(index)}
        disabled={parseFloat(watch('cashbackMethodsQuantity')) - 1 === index}
      />
      <Input
        bootstrap={'col-12 col-md-2'}
        label={`Monto Bs Vuelto ${index + 1} *`}
        type={'number'}
        name={`returnedAmountBsS${index}`}
        register={register}
        placeholder={''}
        errors={errors[`returnedAmountBsS${index}`]?.message}
        disabled={true}
      />
      <Input
        bootstrap={'col-12 col-md-2'}
        label={`Referencia Vuelto ${index + 1} *`}
        type={'text'}
        name={`returnedReference${index}`}
        register={register}
        placeholder={''}
        errors={errors[`returnedReference${index}`]?.message}
      />
      <div className="col-12 col-md-4">
        <FileDropzone
          handleDrop={handleDrop}
          index={index}
          file={file}
          removeFile={removeFile}
          error={errorsDropzone?.[`error${index}`]}
        />
      </div>
    </>
  );
};


const CashbackPMInfo = ({ watch, i }) => {
  return (
    <div>
      <h6 style={{ fontSize: "12px" }}><b>Banco:</b> {banksOptions?.find(option => option._id === watch(`cashBackbank${i}`))?.name}</h6>
      <h6 style={{ fontSize: "12px" }}><b>Telefono:</b> {watch(`cashBackphone${i}`)}</h6>
      <h6 style={{ fontSize: "12px" }}><b>CI/RIF:</b> {watch(`cashBackIdentificationType${i}`)}-{watch(`cashBackIdentification${i}`)}</h6>
    </div>
  )
}